/* ============
 * State of the Units module
 * ============
 *
 * The initial state of the Units module.
 */

export default {
  units: [],
  currentUnit: null,
  favourites: [],
  crop: false,
};
